<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="label solo">
				Quel est votre horizon d'investissements ? (1 réponse possible)
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input">
					<custom-select :solo="true" :items="perspectives" :selected="perspective" @change="perspective=$event" />
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				Quels sont vos objectifs d'investissement prioritaires ? (plusieurs réponses possibles)
			</div>
			<div class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in objectives" v-bind:key="key" :class="{active: isActiveTag(tag)}" @click="toggleTag(tag)">
					{{ tag }}
				</div>
			</div>
			<div class="label solo">
				Quel degrès de risque êtes-vous prêt à accepter pour atteindre vos objectifs ? (1 réponse possible)
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input">
					<custom-select :solo="true" :items="riskDegrees" :selected="riskDegree" @change="riskDegree=$event" />
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				En cas d'investissement sur les marchés financiers quel niveau de hausse aimeriez vous atteindre ?
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input">
					<custom-select :solo="true" :items="risingMarkets" :selected="risingMarket" @change="risingMarket=$event" />
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				Selon le paysage patrimonial que vous venez de décrire l'estimation de votre patrimoine global se situe ?
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input">
					<custom-select :solo="true" :items="assetsEstimates" :selected="assetsEstimate" @change="assetsEstimate=$event" />
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				Si vous deviez effectuer un nouvel investissement, que représenterait ce montant au regard de votre patrimoine global ?
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input">
					<custom-select :solo="true" :items="investmentsEstimates" :selected="investmentsEstimate" @change="investmentsEstimate=$event" />
				</div>
				<div class="error-message"></div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import { Perspective, Objective, RiskDegree, RisingMarket, AssetsEstimate, InvestmentEstimate } from '@/common/components/MyPatrimonialLandscape/data/Perspective'
import { mapGetters } from 'vuex'

export default {
	name: 'Perspective',
	components: {
		CustomSelect
	},
	data () {
		return {
			perspectives: Perspective,
			objectives: Objective,
			riskDegrees: RiskDegree,
			risingMarkets: RisingMarket,
			assetsEstimates: AssetsEstimate,
			investmentsEstimates: InvestmentEstimate,
			perspective: null,
			objective: [],
			riskDegree: null,
			risingMarket: null,
			assetsEstimate: null,
			investmentsEstimate: null
		}
	},
	mounted () {
		this.perspective = this.estate.perspective.perspective || this.perspectives[0]
		this.objective = Array.from(this.estate.perspective.objective) || []
		let tmpObjective = []
		this.objective.forEach((objective) => {
			if (Objective.indexOf(objective) !== -1) {
				tmpObjective.push(objective)
			}
		})
		this.objective = tmpObjective
		this.riskDegree = this.estate.perspective.riskDegree || this.riskDegrees[0]
		this.risingMarket = this.estate.perspective.risingMarket || this.risingMarkets[0]
		this.assetsEstimate = this.estate.perspective.assetsEstimate || this.assetsEstimates[0]
		this.investmentsEstimate = this.estate.perspective.investmentsEstimate || this.investmentsEstimates[0]
	},
	methods: {
		toggleTag (value) {
			if (this.objective.indexOf(value) === -1) {
				this.objective.push(value)
			} else {
				this.objective.splice(this.objective.indexOf(value), 1)
			}
		},
		isActiveTag (value) {
			return (this.objective.indexOf(value) !== -1)
		},
		validate () {
			return new Promise((resolve, reject) => {
				resolve(true)
			})
		},
		save () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('storePatrimonial', {
					name: 'PERSPECTIVE',
					data: {
						perspective: this.perspective,
						objective: this.objective,
						riskDegree: this.riskDegree,
						risingMarket: this.risingMarket,
						assetsEstimate: this.assetsEstimate,
						investmentsEstimate: this.investmentsEstimate
					},
					fromStart: false
				}).then(() => {
					resolve()
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="scss" scoped>
.form-ui.landscape-patrimonial-ui {
	.label.solo {
		margin-top: 2rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Perspective.vue